import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Props } from 'docz';
import Code from '../../docz/code/index';
import { VideoPlayer } from '../../src/index';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h1 {...{
      "id": "components"
    }}>{`Components`}</h1>
    <hr></hr>
    <h2 {...{
      "id": "videoplayer"
    }}><inlineCode parentName="h2">{`VideoPlayer`}</inlineCode></h2>
    <p><inlineCode parentName="p">{`VideoPlayer`}</inlineCode>{` is the component that comunicate all the components with the HTML5 video API. Internally, it's a provider.`}</p>
    <Code mdxType="Code">
  {`
import { VideoPlayer, Viewer } from 'react-trailer';\n
<VideoPlayer>
  <Viewer
    url="http://dl5.webmfiles.org/big-buck-bunny_trailer.webm"
    nativeControls
  />
</VideoPlayer>
  `.trim()}
    </Code>
    <h3 {...{
      "id": "properties"
    }}>{`Properties`}</h3>
    <Props of={VideoPlayer} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      